// Firestore document of a perfume, without the Firestore web SDK (only its types): also used by
// the Cloud Functions (functions/src), where documents are read with firebase-admin
import { ComponentCategory, type Perfume } from "@/models/Perfume";
import { adaptPerfumeWorkshopLocation } from "@/models/WorkshopLocation";
import type { Timestamp } from "firebase/firestore";

function adaptPerfumeComponentCategory(db: string): ComponentCategory {
  const category = ComponentCategory[db as keyof typeof ComponentCategory];
  if (category === undefined) {
    throw new Error(`Unknown ComponentCategory: ${db}`);
  }
  return category;
}

export interface PerfumeComponentDb {
  name: string;
  volume: number;
  category: string;
  numeroDeLot: string | null;
  // only stored when true
  suggested?: boolean;
}

export interface PerfumeDb {
  formulaNumber: string;
  created: Timestamp;
  name: string;
  email: string;
  title?: string;
  username?: string;
  userLastName?: string;
  components: PerfumeComponentDb[];
  workshopLocationId: string;
  comment?: string;
  lockedAt?: Timestamp | null;
}

// `recipeId` is the document id
export function perfumeFromDb(recipeId: string, db: PerfumeDb): Perfume {
  return {
    recipeId,
    formulaNumber: db.formulaNumber ? db.formulaNumber : null,
    created: db.created.toDate(),
    name: db.name,
    email: db.email,
    title: db.title || "",
    username: db.username || "",
    userLastName: db.userLastName || "",
    workshopLocation: adaptPerfumeWorkshopLocation(db.workshopLocationId),
    components: db.components.map((component: PerfumeComponentDb) => {
      return {
        name: component.name,
        volume: component.volume,
        category: adaptPerfumeComponentCategory(component.category),
        numeroDeLot: component.numeroDeLot ?? null,
        suggested: component.suggested === true,
      };
    }),
    comment: db.comment || "",
    lockedAt: db.lockedAt?.toDate() ?? null,
  };
}
